import {ScoringSystemItems} from '../types';

export function processScoringSystems(scoringSystems: Record<string, ScoringSystemItems>) {
  return Object.keys(scoringSystems).map((scoringSystemKey) => ({
    scoringSystem: scoringSystemKey,
    scoringSystemItems: Object.keys(scoringSystems[scoringSystemKey] as ScoringSystemItems).map(
      (scoringSystemItemId) => ({
        scoringSystemItem: scoringSystemItemId,
        value: (scoringSystems[scoringSystemKey] as ScoringSystemItems)[scoringSystemItemId]
      })
    )
  }));
}

export function processAnamnesisQuestions(anamnesisAnswers: Record<string, string>) {
  return Object.keys(anamnesisAnswers).map((anamnesisQuestionId) => ({
    anamnesisQuestion: anamnesisQuestionId,
    answer: anamnesisAnswers[anamnesisQuestionId]
  }));
}
